import React, { useEffect, useState } from "react";
import { CommentPropType, ItemPropType } from "../../PropTypes";
import PropTypes from "prop-types";
import CommentList from "../CommentList/CommentList";
import ContributionImage from "../ContributionImage/ContributionImage";
import { FormattedDateTime } from "../FormattedDateTime";
import Modal from "../Modal/Modal";
import ReplyModal from "../Modals/ReplyModal";
import { connect } from "react-redux";
import { selectors, dismissError } from "../../app/slices/itemSlice";
import Avatar from "../Avatar/Avatar";
import CommentOptions from "../CommentOptions/CommentOptions";
import "./comment.scss";
import YouTubeVideo from "../YouTube/YouTube";
import { IsUserLoggedIn } from '../../helpers/authHelper';
import {
  selectors as mediaSelectors,
  setShowGallery,
  setGalleryIndex,
} from "../../app/slices/mediaSlice";
import LazyLoad from "../LazyLoad";
import { encodeProfileURL } from '../../helpers/urlHelper';
import { noListEntryFound } from "../../constants/errorMessages";
import { removeSpaces } from "../../helpers/utilities";

function Comment(props) {
  const [showReply, setShowReply] = useState(false);
  const {
    REACT_APP_SIGNINURL
  } = process.env;

  const { media, setShowGallery, setGalleryIndex, showGallery } = props;
  const item = props.item ?? props.comment?.item;

  const comments = [];
  if (props.comment.media && props.comment.media.length) {
    props.comment.media.forEach(() => comments.push(props.comment));
  }

  const captions = [];
  if (props.comment.media && props.comment.media.length) {
    props.comment.media.forEach((i) => captions.push(i.caption));
  }

  function handleImageClick(url) {
    if (Array.isArray(media)) {
      media.filter(({ mediaTypeId }) => mediaTypeId !== 4).map((mediaItem, i) => {
        if (mediaItem.url === url) {
          setGalleryIndex(i);
        }
      })
    }
    setShowGallery(!showGallery);
  }

  /**
   * Generate url depending on whether or not the comment was made by an organisation user
   * @param {*} username 
   * @returns 
  */
    function generateUrl(username) {
      return props.comment.isCreatedByOrganisationUser ? encodeProfileURL(username) : encodeProfileURL(removeSpaces(username), props.comment.memberId); 
    }

  /** 
   * Get the item name or location
   * If the item name is "No name for this entry" and if the address is not empty show the address
   * Else show the item name
  */
  function getItemNameOrLocation() { 
    // check if the item location is null, if it is return the name
    if(item.location === null) {
      return item.name; 
    }
    return item.name.toLowerCase() === noListEntryFound.toLowerCase() && item.location.address !== "" ? item.location.address : item.name;
  }
  
  function processText(text) {
    if (text === undefined || text === null || text === "") {
      return "";
    }
    let newText = text;
    let urlRegex = /\(?http[\S]+|www[\S]+/gm;
    let dupRegex = /\[http|\[www|\[(?:[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*)@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)/gm;
    let emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*)@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)/gm;
    const noHttpRegex = /^(?!http)/;

    // Remove any duplicated urls and mailto links.
    let duplicateUrls = [...newText.matchAll(dupRegex)];
    for (let i = 0; i < duplicateUrls.length; i++) {
      let index = newText.indexOf(duplicateUrls[i]);
      let endIndex = newText.indexOf("]", index);
      let duplicatedUrlText = newText.slice(index > 0 ? index - 1 : 0, endIndex + 1);
      newText = newText.replace(duplicatedUrlText, "");
    }

    // Make mailto into links
    let emailAddresses = [...newText.matchAll(emailRegex)];
    for (let i = 0; i < emailAddresses.length; i++) {
      newText = newText.replace(emailAddresses[i], `<a href="mailto:${emailAddresses[i]}">${emailAddresses[i]}</a>`);
      let index = newText.indexOf(`<a href="mailto:${emailAddresses[i]}">${emailAddresses[i]}</a>`);
      if (newText.substr(index - 7, 7) === 'mailto:') {
        newText = newText.replace('mailto:', '');
      }
    }

    // Create links
    let urls = [...newText.matchAll(urlRegex)];
    for (let i = 0; i < urls.length; i++) {
      let urlText = urls[i][0];

      // Remove any initial "(" and any trailing "." or ")" from the link text.
      while (urlText.charAt(0) === '(') {
        urlText = urlText.substring(1);
      }

      while (urlText.lastIndexOf('.') === urlText.length - 1 ||
      urlText.lastIndexOf(')') === urlText.length - 1) {
        urlText = urlText.slice(0, -1);
      }

      // Add http if not present
      const href = noHttpRegex.test(urlText) ? `http://${urlText}` : urlText;
      newText = newText.replace(urls[i][0], `&nbsp;<a href="${href}">${urlText}</a>`);
    }

    // Keep a maximum of two line breaks in a row
    newText = newText.replace(/(?:\r\n|\r|\n)/g, '<br>').replace(/(<br>){3,}/g, '<br><br>');

    return newText;
  }

  const closeRootModal = () => {
    setShowReply(false);
    window.removeEventListener('popstate', closeRootModal);
  };

  useEffect(() => {
    document.documentElement.style.overflow = showReply ? 'hidden' : '';
    showReply && window.history.pushState({}, '');
    showReply && window.addEventListener('popstate', closeRootModal);
  }, [showReply]);

  if (props.comment) {
    let commentPath = null;
    if (item.path) {
      commentPath = new URL(item.path);
    }

    let commentText = processText(props.comment.text);

    return (
      <article className={`ugc-comment ${props.index < 1 ? 'ugc-comment--first-item' : 'ugc-comment--not-first-item'}`}
               itemProp="comment"
               itemScope
               itemType="http://schema.org/Comment">
        {
          props.comment.pinnedPriority > 0 &&
          <small className="ugc-comment__pinned-priority">
            <span className="icon icon--pin"/>
            Pinned by Historic England
          </small>
        }

        {/* At a contribution level, we use the .archived flag on the implementation to check if it is open or closed to contributions  */}
        {
          !item.implementation.archived
            ? showReply && (
            <Modal
              closeRootModal={closeRootModal}
              confirmClose={true}
              dismissError={props.dismissError}
              isSmallModal={true}>
              <ReplyModal
                closeRootModal={closeRootModal}
                parentId={props.comment.id}
                confirmClose={true}/>
            </Modal>
          )
            : null}

        {
          props.comment.isLoggedInUsersComment &&
          <CommentOptions comment={props.comment}
                          item={item}/>
        }


        {
          !props.profilePage &&
          <div className="ugc-comment__profile-section">
            <Avatar
              username={props.comment.username}
              src={props.comment.userAvatarUrl}/>

              <div className="ugc-comment__profile-info">
              <p
                 itemProp="author">
                {
                    props.comment.memberId !== "" && props.comment.username !== "Anonymous User" ? (
                        props.comment.isUserVerified ? (
                            <a href={generateUrl(props.comment.username)}>{props.comment.username}</a>
                        ) : <span>{props.comment.username}</span>
                    ) : "Anonymous User"
                }
              </p>
              <p>
              <time itemProp="commentTime"
                    dateTime={props.comment.created}>
                {FormattedDateTime(props.comment.created)}
              </time>
              {
                props.comment.edited && 
                              <span> (Edited)</span>
              }
              </p>
            </div>
          </div>
        }

        {
          props.profilePage &&
          <p className="ugc-comment__profile-page">
            Contributed to:&nbsp;
            {
              commentPath ?
                <a href={`${window.location.origin}${commentPath.pathname}`}
                   aria-label="Go to comment">
                  {item.implementation.name} ({getItemNameOrLocation()})
                </a>
                :
                <>{item.implementation.name} ({getItemNameOrLocation()})</>
            }
            &nbsp;on <span>{FormattedDateTime(props.comment.created)}</span> 
            {
              props.comment.edited && 
                              <span> (Edited)</span>
            }
          </p>
        }

        {
          props.comment.text &&
          <div itemProp="text">
              <p className="ugc-comment__comment-text"
               dangerouslySetInnerHTML={{ __html: commentText }}>
            </p>
          </div>
        }
        {
          props.comment.media &&
          <div className="ugc-comment__gallery">
            <div className="he-grid-row">
              {
                props.comment.media.map((media) =>
                  media.mediaTypeId === 4 ?
                    <div className="ugc-comment__gallery-item-wrapper he-grid-col-md-6">
                      <YouTubeVideo url={media.url}/>
                    </div>
                    :
                    <div className="ugc-comment__gallery-item-wrapper he-grid-col-md-6">
                      <LazyLoad>
                        {captions
                          .map((sourceIndex) => (
                            <figure key={sourceIndex}>
                              <ContributionImage
                                key={media.id}
                                id={media.id}
                                externalId={props.externalId}
                                filename={media.filename}
                                quality={80}
                                starred={media.starred}
                                description={media.description}
                                caption={media.caption}
                                mediaArrayLength={props.comment.media.length}
                                itemIndex={sourceIndex}
                                url={media.url}
                                hideLoadingSpinner
                                onClick={() => handleImageClick(media.url)}
                                allowFullScreen
                              />
                              {media.caption}
                            </figure>
                          ))
                          .slice(0, 1)
                        }
                      </LazyLoad>
                    </div>
                )
              }
            </div>
          </div>
        }
        <div className="ugc-comment__reply-section">
          {
            !props.item.implementation.archived &&
            !props.isReply &&
            !props.profilePage &&
            <div className="ugc-comment__reply-actions">
              <span className="icon icon--comment-lines"/>
              {
                IsUserLoggedIn() ?
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setShowReply(!showReply);
                    }}
                    data-component="ugcCommentReplyButtonUserSignedIn">
                    {props.replyButtonText}
                  </a>
                  :
                  <a rel="nofollow"
                    href={`${REACT_APP_SIGNINURL}/?u=&referrer=${window.location}`}
                    data-component="ugcCommentReplyButtonUserSignedOut">
                    Sign in to reply
                  </a>
              }
            </div>
          }

          {
            props.comment.replies && props.comment.replies.length > 0 &&
            <CommentList
              isReply={true}
              profilePage={props.profilePage}
              comments={props.comment.replies}
              item={item}/>
          }

        </div>
      </article>
    );
  }

  return null;
}

Comment.propTypes = {
  comment: CommentPropType.isRequired,
  media: PropTypes.array,
  item: ItemPropType
};

const mapStateToProps = (state) => {
  return {
    replyButtonText: selectors.replyButtonText(state),
    media: mediaSelectors.media(state),
    showGallery: mediaSelectors.showGallery(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setShowGallery: (showGallery) => dispatch(setShowGallery(showGallery)),
    setGalleryIndex: (galleryIndex) => dispatch(setGalleryIndex(galleryIndex)),
    dismissError: () => dispatch(dismissError()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Comment);
